
import iconShengchan from "../../assets/svg/icon-shengchan.svg";
export default {
  path: "/kun_tie",
  redirect: "/kun_tie/index",
  name: "kun_tie_index",
  meta: {
    icon: iconShengchan,
    title: "鲲贴",
    rank:5,
    // roles: ['kun_tie_router']

  },
  children: [

    {
      path: "/kun_tie/index",
      name: "KunTie",
      component: () => import("@/views/kunTie/index.vue"),
      meta: {
        title: "鲲贴",
        keepAlive: false,
        roles: ['kuntie']
      }
    },

  ]
} as RouteConfigsTable;
